module.exports = __webpack_public_path__ + "media/images/appstore-icon-728da860c8f041d179155fff92e6aef3.png";